/**
 * Kokū deck nudge.
 * One click raises the deck line in the cart by one.
 * Uses Shopify.actions.updateCart so Horizon's cart drawer re-renders itself.
 */

const SELECTOR = '[data-koku-nudge]';

/**
 * @param {HTMLButtonElement} button
 */
async function addOne(button) {
  const key = button.dataset.key;
  const quantity = Number(button.dataset.quantity);
  if (!key || !quantity) return;

  button.disabled = true;
  button.setAttribute('aria-busy', 'true');

  const actions = window.Shopify?.actions;

  try {
    if (actions?.updateCart) {
      const result = await actions.updateCart(
        { lines: [{ id: key, quantity }] },
        { event: { context: 'cart', detail: { source: 'koku-cart-nudge' } } }
      );
      if (result?.userErrors?.length) {
        throw new Error(result.userErrors.map((e) => e.message).join(', '));
      }
      return;
    }

    // Fallback when standard actions are unavailable: one AJAX change, then reload.
    const url = window.Theme?.routes?.cart_change_url || '/cart/change.js';
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    if (!response.ok) throw new Error(`Cart change failed (${response.status})`);
    window.location.reload();
  } catch (error) {
    console.warn('[koku-cart-nudge]', error);
    button.disabled = false;
    button.removeAttribute('aria-busy');
  }
}

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target.closest(SELECTOR) : null;
  if (!(target instanceof HTMLButtonElement) || target.disabled) return;
  event.preventDefault();
  addOne(target);
});
